// CLASSES
import AppConfig from "@classes/AppConfig";
import Validator from "@classes/Validator";


export default function (props, state) {
	if (AppConfig.get("developmentOptions").ignoreFullfillment === true) {
		return true;
	}

	const {fields, validFields} = state;

	for (const name in validFields) {
		if (validFields[name] === false) {
			return false;
		}
	}

	let hasAtLeastOneSignatory = false;

	for (let i = 0; i < state.numberOfCompanyReps; i++) {
		let allFieldsValid = true;

		allFieldsValid = allFieldsValid && fields['company_representative_firstname_' + i].length > 0;
		allFieldsValid = allFieldsValid && fields['company_representative_lastname_' + i].length > 0;
		allFieldsValid = allFieldsValid && fields['company_representative_citizenship_' + i].length > 0;
		allFieldsValid = allFieldsValid && Validator.validateEmail(fields['company_representative_email_' + i]);
		allFieldsValid = allFieldsValid && Validator.validateSsn(fields['company_representative_sec_num_' + i]);

		if (fields["checkbox_signatory_" + i]) {
			hasAtLeastOneSignatory = true;
		}

		if (!allFieldsValid) {
			return false;
		}
	}

	/**
	 * Åtminstone en firmatecknare måste väljas
	 */
	if (!hasAtLeastOneSignatory) {
		return false;
	}

	/**
	 * If the partner shows Förvaltarfullmakt rather than Fullmakt we need to make sure at least one person has
	 * this property set.
	 */
	if (state.forceAtLeastOneForvaltarfullmakt) {
		let hasAtLeastOneForvaltarFullmakt = false;
		for (let i = 0; i < state.numberOfCompanyReps; i++) {
			if (fields["checkbox_mng_" + i]) {
				hasAtLeastOneForvaltarFullmakt = true;
				break;
			}
		}

		if (!hasAtLeastOneForvaltarFullmakt) {
			return false;
		}
	}

	return true;
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Poa/Poa.fulfillment.js